import React from 'react';

interface DashboardProps {
  color?: string; 
}

const Dashboard: React.FC<DashboardProps> = ({ color = "#086D33" }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.45 11.7165L15.5 9.6665M10 13.1665C10 13.6969 10.2107 14.2056 10.5858 14.5807C10.9609 14.9558 11.4696 15.1665 12 15.1665C12.5304 15.1665 13.0391 14.9558 13.4142 14.5807C13.7893 14.2056 14 13.6969 14 13.1665C14 12.6361 13.7893 12.1274 13.4142 11.7523C13.0391 11.3772 12.5304 11.1665 12 11.1665C11.4696 11.1665 10.9609 11.3772 10.5858 11.7523C10.2107 12.1274 10 12.6361 10 13.1665Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4 20.1667C4.93815 19.0047 3.87391 17.4169 3.35478 15.6231C2.83564 13.8294 2.88732 11.9185 3.50265 10.1555C4.11797 8.39239 5.26647 6.86437 6.78899 5.78316C8.3115 4.70195 10.1326 4.12109 12 4.12109C13.8674 4.12109 15.6885 4.70195 17.211 5.78316C18.7335 6.86437 19.882 8.39239 20.4974 10.1555C21.1127 11.9185 21.1644 13.8294 20.6452 15.6231C20.1261 17.4169 19.0619 19.0047 17.6 20.1667H6.4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Dashboard;
